export default __webpack_public_path__ + "app/views/administration/about/about.html";